// extracted by mini-css-extract-plugin
module.exports = {"block":"CustomCheckbox__block__34alG","root":"CustomCheckbox__root__3RVM0","checked":"CustomCheckbox__checked__2uCZ1"};